import { useQuery } from "@tanstack/react-query"
import { apiFetch } from "../framework/api"
import { useAuthToken } from "./useAuthToken"

export type PlaceDetail = {
  id: string
  name: string
  type: string
  latitude: number
  longitude: number
  osmRef: string
  updatedAt: string
  mergedProps?: Record<string, unknown> | null
}

export function usePlaceDetail(id?: string) {
  const token = useAuthToken()

  return useQuery({
    queryKey: ["place", id],
    enabled: Boolean(id),
    queryFn: async () => {
      const data = await apiFetch<PlaceDetail>(`/admin/places/${id}`, {
        token,
        method: "GET",
      })
      return data
    },
  })
}
